import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeInfoModal } from '../actions';

require('./index.css');
 
const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    padding               : '0',
    borderRadius          : '5px',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    background            : '#e9e9e9'
  }
};
 
class InfoModal extends Component {
    render() {
        const { infoModalIsOpen, closeInfoModal, infoModalDetails } = this.props;
        return (
            <div>
                <Modal
                    isOpen={ infoModalIsOpen }
                    onRequestClose={ closeInfoModal }
                    style={ customStyles }
                >       
                    <h6 className='modal-header'>
                        Instructions 
                        <span style={{ textAlign: 'right' }}>Demo v1.0</span>
                    </h6>
                    <div className='modal-body info-modal'>
                        {(infoModalDetails === 'desktop') &&
                            <div>
                                <h6 className='info-header'>Desktop Instructions</h6>
                                <ul>
                                    <li>Click on the screen and drag to move diagrams.</li>
                                    <li>Hover mouse over a nerve, muscle, or entrapment point to view label.</li>
                                    <li>Hover mouse over a nerve to highlight affected muscles in red.</li>
                                    <li>Click anywhere along a nerve to select point.</li>
                                    <li>Modal will open with list of affected nerves, muscles and/orinnervations for the selected point.</li>
                                    <li>Click close button/outside the modal/escape Key to close modal.</li>
                                </ul>
                            </div>
                        }
                        {(infoModalDetails === 'mobile') &&
                            <div>
                                <h6 className='info-header'>Mobile Instructions</h6>
                                <ul>
                                    <li>Touch on the screen and drag to move diagrams.</li>
                                    <li>Touch a nerve, muscle, or entrapment point to view label.</li>
                                    <li>Touch a nerve to highlight affected muscles in red.</li>
                                    <li>Tap anywhere along a nerve to select point.</li>
                                    <li>Modal will open with list of affected nerves, muscles and/orinnervations for the selected point.</li>
                                    <li>Tap close button/outside the modal/escape Key to close modal.</li>
                                    <li>All highlighted muscles will be reset to blue when modal closes.</li>
                                </ul>
                            </div>
                        }
                    </div>
                    <div className='btn-modal'>
                        <button className='btn btn-secondary' onClick={ closeInfoModal }>Close</button>
                    </div>
                </Modal>
            </div>
        );
    }
}

//-----Redux Functions-----
const mapStateToProps = (state) => {
    return {
        infoModalIsOpen: state.infoModalState,
        infoModalDetails: state.infoModalDetails  
    }
}

const mapDispatchToProps = (dispatch) => {
   return bindActionCreators({ closeInfoModal }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(InfoModal);


// WEBPACK FOOTER //
// ./src/infoModal/index.js